export default __webpack_public_path__ + "static/media/CLOCK_ICONA.f9305b3b.svg";